import React from 'react';
import Badge from '../ui/Badge';
import Button from '../ui/Button';

const FilterMenu = ({ label, count, children }) => {
  return (
    <details className="sp-filter-menu">
      <summary>
        <span>{label}</span>
        {count > 0 && <Badge variant="review">{count}</Badge>}
      </summary>
      <div className="sp-filter-menu__panel">{children}</div>
    </details>
  );
};

const FilterPill = ({ label, onRemove }) => {
  return (
    <span className="sp-filter-pill">
      {label}
      <button type="button" onClick={onRemove} aria-label={`Remove filter ${label}`}>
        ×
      </button>
    </span>
  );
};

export default function IncidentsFilterBar({
  search,
  onSearchChange,
  filters,
  typeOptions,
  severityOptions,
  statusOptions,
  resultsCount,
  activeFilters,
  onToggleType,
  onToggleSeverity,
  onToggleStatus,
  onAssignmentChange,
  onFollowUpChange,
  onClearFilters,
  onRemoveFilter
}) {
  return (
    <div className="sp-filter-bar" role="region" aria-label="Incident filters">
      <div className="sp-filter-main">
        <div className="sp-filter-search">
          <label className="sp-label" htmlFor="incident-search">Search</label>
          <input
            id="incident-search"
            className="sp-input w-full"
            placeholder="Search by type, student, description, assigned staff"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
          />
        </div>
        <div className="sp-filter-controls">
          <FilterMenu label="Type" count={filters.types.length}>
            {typeOptions.map((type) => (
              <label key={type} className="sp-filter-option">
                <input
                  type="checkbox"
                  checked={filters.types.includes(type)}
                  onChange={() => onToggleType(type)}
                />
                <span>{type}</span>
              </label>
            ))}
            {typeOptions.length === 0 && <span className="text-xs sp-muted">No types found.</span>}
          </FilterMenu>
          <FilterMenu label="Severity" count={filters.severities.length}>
            {severityOptions.map((severity) => (
              <label key={severity.value} className="sp-filter-option">
                <input
                  type="checkbox"
                  checked={filters.severities.includes(severity.value)}
                  onChange={() => onToggleSeverity(severity.value)}
                />
                <span>{severity.label}</span>
              </label>
            ))}
          </FilterMenu>
          <FilterMenu label="Status" count={filters.statuses.length}>
            {statusOptions.map((status) => (
              <label key={status.value} className="sp-filter-option">
                <input
                  type="checkbox"
                  checked={filters.statuses.includes(status.value)}
                  onChange={() => onToggleStatus(status.value)}
                />
                <span>{status.label}</span>
              </label>
            ))}
          </FilterMenu>
          <FilterMenu label="Assignment" count={filters.assignment !== 'all' ? 1 : 0}>
            {['all', 'assigned', 'unassigned'].map((value) => (
              <label key={value} className="sp-filter-option">
                <input
                  type="radio"
                  name="assignmentFilter"
                  value={value}
                  checked={filters.assignment === value}
                  onChange={() => onAssignmentChange(value)}
                />
                <span>
                  {value === 'all' ? 'All' : value === 'assigned' ? 'Assigned' : 'Unassigned'}
                </span>
              </label>
            ))}
          </FilterMenu>
          <FilterMenu label="Follow-up" count={filters.followUp !== 'any' ? 1 : 0}>
            {[
              { value: 'any', label: 'Any' },
              { value: 'required', label: 'Required' },
              { value: 'none', label: 'None' },
              { value: 'dueSoon', label: 'Due soon (7 days)' },
              { value: 'overdue', label: 'Overdue' }
            ].map((option) => (
              <label key={option.value} className="sp-filter-option">
                <input
                  type="radio"
                  name="followUpFilter"
                  value={option.value}
                  checked={filters.followUp === option.value}
                  onChange={() => onFollowUpChange(option.value)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </FilterMenu>
        </div>
        <div className="sp-filter-meta">
          <span className="text-sm sp-muted">{resultsCount} results</span>
          {activeFilters.length > 0 && (
            <Button variant="ghost" size="sm" onClick={onClearFilters} type="button">
              Clear filters
            </Button>
          )}
        </div>
      </div>

      {activeFilters.length > 0 && (
        <div className="sp-filter-pills" aria-label="Active filters">
          {activeFilters.map((filter) => (
            <FilterPill key={filter.id} label={filter.label} onRemove={() => onRemoveFilter(filter)} />
          ))}
        </div>
      )}
    </div>
  );
}
